import { render, staticRenderFns } from "./VimeoContainer.vue?vue&type=template&id=3df57e07&"
import script from "./VimeoContainer.vue?vue&type=script&lang=ts&"
export * from "./VimeoContainer.vue?vue&type=script&lang=ts&"
import style0 from "./VimeoContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports